import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useCourse } from '../contexts/CourseContext';

export function useConsentStatus() {
  const { currentCourse } = useCourse();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [consentGiven, setConsentGiven] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      try {
        if (!currentCourse) {
          setConsentGiven(false);
          return;
        }
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setConsentGiven(false);
          return;
        }
        const { data, error } = await supabase
          .from('course_learner_preferences')
          .select('consent_given')
          .eq('user_id', user.id)
          .eq('course_id', currentCourse.id)
          .maybeSingle();
        if (error && (error as any).code !== 'PGRST116') {
          console.warn('[useConsentStatus] Error fetching consent:', error);
          setConsentGiven(false);
          return;
        }
        if (!cancelled) setConsentGiven(Boolean(data?.consent_given));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    // Re-check consent on course change and on route changes (e.g., after navigating
    // from landing -> preferences -> chat) so header nav reflects latest state.
    load();
    return () => { cancelled = true; };
  }, [currentCourse, location.pathname]);

  return { loading, consentGiven } as const;
}
